import { render, staticRenderFns } from "./sound.vue?vue&type=template&id=de89ad74&scoped=true"
import script from "./sound.vue?vue&type=script&lang=js"
export * from "./sound.vue?vue&type=script&lang=js"
import style0 from "./sound.vue?vue&type=style&index=0&id=de89ad74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de89ad74",
  null
  
)

export default component.exports